import { Component } from "@angular/core";
import { FormService } from "@hub/services/form.service";


@Component({
  selector: "tab-footer",
  templateUrl: "./tab-footer.component.html"
})
export class TabFooterComponent {
  constructor(
    public formService: FormService
  ) {
  }

  showButtons: boolean = true;

  save(param?: boolean) {
    if (param === undefined) {
      this.formService.saveClick();
    } else {
      this.formService.saveClick(param);
    }
  }

  cancel() {
    this.formService.closeClick();
  }
}
